import { defineStore } from 'pinia'
import { ref } from 'vue'

import { HS_HIDE_CLASS } from '@/lib/hubspotChat'

type HubSpotWidget = {
  open: () => void
  close: () => void
  status: () => { loaded?: boolean }
}

const getHubspotWidget = (): HubSpotWidget | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).HubSpotConversations?.widget
}

export const useSupportWidgetsStore = defineStore('supportWidgets', () => {
  const liveChatReady = ref(false)

  const markLiveChatReady = (): void => {
    liveChatReady.value = true
  }

  /**
   * HubSpot adds `hs-messages-widget-open` to <html> while the panel is open.
   * Reading the DOM is immune to callback-driven state-sync bugs.
   */
  const isWidgetOpen = (): boolean =>
    document.documentElement.classList.contains('hs-messages-widget-open')

  const openLiveChat = (): void => {
    try {
      const widget = getHubspotWidget()
      if (!widget?.status()?.loaded) return

      if (isWidgetOpen()) {
        widget.close()
      } else {
        // In the ProductFruits life-ring config the container is kept hidden via
        // this class; remove it so the panel is visible when opened from here.
        document.documentElement.classList.remove(HS_HIDE_CLASS)
        widget.open()
      }
    } catch {
      // widget not loaded yet
    }
  }

  return { liveChatReady, markLiveChatReady, openLiveChat }
})
